import State from 'interfaces/state/State';

export const isError$ = (state: State) => state.updateApprove.isError;
export const isLoading$ = (state: State) => state.updateApprove.isLoading;
export const approve$ = (state: State) => state.updateApprove.approve;
